export const OPINION_FITLER = {
  RECENT: 'recent',
  TRENDING: 'trending',
};
